// screens/settings/AccountSetting.js
import React, { useRef, useState, useCallback, useEffect, useMemo, useRef as useRefAlias, startTransition } from 'react';
import { Box, IconButton, Checkbox, FormControl, InputLabel, Select, MenuItem, CircularProgress,Tabs,Tab, TextField } from '@mui/material';
import CustomText, { textStyles } from '../../../components/CustomText';
import MultiSelectDropdown from '../../../components/MultiSelectionDropdown';
import CustomButton from '../../../components/CustomButton';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import '../../../App.css';
import back from "../../../assets/back.svg";
import deleteicon from "../../../assets/Settings/deleteicon.svg";
import usa from "../../../assets/usa.png";
import germany from "../../../assets/germany.png";
import france from "../../../assets/france.webp";
import italy from "../../../assets/italy.png";
import down from '../../../assets/down.svg';
import save from '../../../assets/save.svg';
import profileperson from "../../../assets/profileperson.png";
import dummy from "../../../assets/dummy.png";
import { useTranslation } from "react-i18next";
import Location from './Location';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from '../../../components/BaseUrl';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setProfile } from '../../../Redux/Slices/profileSlice';
import { showToast } from '../../../Utlis/messageHandler';
import ChangePasswordSettings from './changePassword';
import Webcam from "react-webcam";
import Menu from "@mui/material/Menu";
import AddIcon from "@mui/icons-material/Add";
import {
  getCountriesByRegions,
  getCitiesByCountryNames,
} from "../../AuthPages/Registeration/helper";
import { Country, State, City } from "country-state-city";
import SearchableDropdown from '../../../components/SearchComponent';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
const buildImageSrc = (raw, baseUrl, fallback) => {
  if (!raw) return fallback;
  if (raw.startsWith('data:')) return raw;
  if (raw.startsWith('http')) return raw;
  const prefix = raw.startsWith('/') ? '' : '/';
  return `${baseUrl}${prefix}${raw}`;
};

const AccountSetting = ({ onBack }) => {
  const { t } = useTranslation("");
  const theme = useTheme();
const rawEncryptedToken = localStorage.getItem("token");
        const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [savingProfile, setSavingProfile] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false); // for mandatory region error
  const [countriesReady, setCountriesReady] = useState(false);
  
  // Legal document state
  const legalDocInputRef = useRef(null);
  const [legalDocFile, setLegalDocFile] = useState(null);
  const [legalDocUrl, setLegalDocUrl] = useState("");
  const [uploadingLegalDoc, setUploadingLegalDoc] = useState(false);

  // Company dropdown state
  const [companies, setCompanies] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [selectedCountryIso, setSelectedCountryIso] = useState("");
const [selectedStateIso, setSelectedStateIso] = useState("");
  // Location state (like CreateProfile)
  const [manualAddress, setManualAddress] = useState(false);
  const [countriesData, setCountriesData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [previousLocation, setPreviousLocation] = useState(null); // Store previous location
const [activeTab, setActiveTab] = useState(0);  // 0 = profile, 1 = change password, 2 = delete account
const [openPasswordModal, setOpenPasswordModal] = useState(false);
const [deletingAccount, setDeletingAccount] = useState(false);


// 📷 Camera states (shared)
const [showCamera, setShowCamera] = useState(false);
const webcamRef = useRef(null);
const [capturedImage, setCapturedImage] = useState(null);
const [takingPhoto, setTakingPhoto] = useState(false);

// 🎯 Which field opened the camera
// "profile" | "legal"
const [cameraTarget, setCameraTarget] = useState(null);

// ☰ Menu anchors
const [profileMenuEl, setProfileMenuEl] = useState(null);
const [legalMenuEl, setLegalMenuEl] = useState(null);



const openProfileMenu = Boolean(profileMenuEl);
const openLegalMenu = Boolean(legalMenuEl);


const openCameraFor = (target) => {
setCameraTarget(target); // "profile" or "legal"
setCapturedImage(null);
setShowCamera(true);
};

const navigate = useNavigate();
const dispatch=useDispatch()

const capturePhoto = async () => {
  if (!webcamRef.current || !cameraTarget) return;

  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) {
    toast.error("Failed to capture image");
    return;
  }

  setCapturedImage(imageSrc);
  setTakingPhoto(true);

  try {
    const blob = await fetch(imageSrc).then((res) => res.blob());
    const file = new File([blob], "camera.jpg", { type: "image/jpeg" });

    console.log("📸 Camera target:", cameraTarget);
    console.log("📸 File:", file);

    // ===============================
    // PROFILE PICTURE
    // ===============================
    if (cameraTarget === "profile") {
      setUploading(true);

      const formData = new FormData();
      formData.append("image", file);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();
      if (!res.ok || json?.error) {
        throw new Error(json?.message || "Upload failed");
      }

      const raw = extractUploadUrl(json);
      setProfileImageRaw(raw);
      setPreviewUrl(buildDisplayUrl(raw));

      toast.success(t("alerts.accountSettings.imageUploadSuccess"));
      setUploading(false);
    }

    // ===============================
    // LEGAL DOCUMENT
    // ===============================
    if (cameraTarget === "legal") {
      setUploadingLegalDoc(true);

      const uploadedUrl = await uploadToServer(file, "image");
      setLegalDocUrl(uploadedUrl);
      setLegalDocFile({ name: "camera.jpg" });
      formik.setFieldValue("legalDocumentUrl", uploadedUrl);

      toast.success(t("imageUploadedSuccessfully"));
      setUploadingLegalDoc(false);
    }

    setShowCamera(false);
  } catch (err) {
    console.error(err);
    toast.error(err.message || "Upload failed");
    setUploading(false);
    setUploadingLegalDoc(false);
  } finally {
    setTakingPhoto(false);
    setCameraTarget(null);
  }
};
const fetchProfileData = async () => {
  try {
    const res = await fetch(`${BASE_URL}/account-executive/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    console.log("Profile data fetched:", data);
    if (!res.ok || data.error) {
      throw new Error(data.message || "Failed to fetch profile");
    }

    const p = data.data?.profile || {};

    // ✅ hydrate formik with API response
    formik.setValues({
      firstName: p.first_name || "",
      middleName: p.middle_name || "", // 👈 NEW - middle name
      lastName: p.last_name || "",
      community: p.community || "",
      province: p.province || "",
      city: p.city || "",
      country: p.country || "",
      postalCode: p.postal_code || "",
      phone: p.phone || "",
      dob: p.dob ? p.dob.split('T')[0] : "", // 👈 Format DOB for date input (YYYY-MM-DD)
      regions: p.territory_zone || [],
      countriesSel: p.territory_countries || [],
      citiesSel: p.territory_cities || [],
      streetAddress: p.address || "",
      latitude: p.latitude ?? null,
      longitude: p.longitude ?? null,
      timezone: p.timezone || "",
      countryCode: p.countryCode || "",
      region: p.region || "",
      continent: p.continent || "",
      companies: p.companies ? p.companies.map(company => company.id) : [], // 👈 Convert company objects to IDs
    });

    // Store initial location as previous location
    if (p.latitude && p.longitude) {
      setPreviousLocation({
        lat: p.latitude,
        lng: p.longitude,
        address: p.address || ""
      });
    }

    // Set location dropdown values
    if (p.country) {
      setSelectedCountry(p.country);
      // Load states for the country
      const countryData = countriesData.find(c => c.name === p.country);
      if (countryData && countryData.states) {
        setStates(countryData.states.map(state => state.name));
      }
    }
    if (p.province) {
      setSelectedState(p.province);
    }
    if (p.city) {
      setSelectedCity(p.city);
    }

    // Auto-check manual address if country, province, and city exist
    if (p.country && p.province && p.city) {
      // setManualAddress(true);
      // Load cities for the existing state
      loadCitiesForState(p.country, p.province);
      // Update map location based on existing data
      setTimeout(() => {
        geocodeSelection(p.country, p.province, p.city);
      }, 1000); // Small delay to ensure cities are loaded
    }

    // ✅ set profile picture too
    if (p.profile_picture) {
      setProfileImageRaw(p.profile_picture);
      setPreviewUrl(buildDisplayUrl(p.profile_picture));
    }
    
    // ✅ set legal document too - show from API on page load
    // if (p.legalDocumentUrl ) {
    //   setLegalDocUrl(p.legalDocumentUrl );
    //   // Extract filename from URL or use generic name
    //   const filename = p.legalDocumentUrl.split('/').pop() || "Legal document";
    //   setLegalDocFile({ name: filename });
    //   // formik.setFieldValue("legal_document_url", p.legalDocumentUrl);
    //     formik.setFieldValue("legalDocumentUrl",  p.legalDocumentUrl);

    // }
    const rawLegalDoc = p.legal_document_url || "";

if (rawLegalDoc) {
  setLegalDocUrl(rawLegalDoc);

  setLegalDocFile({
    name: rawLegalDoc.split("/").pop() || "Legal document",
  });

  // keep formik in sync with backend
  formik.setFieldValue("legalDocumentUrl", rawLegalDoc);
}
  } catch (err) {
    toast.error(err.message || t("accountSettings.fetchProfileError"));
    if (err.message.toLowerCase().includes("token")) {
      navigate("/"); // if token expired → back to login
    }
  }
};

useEffect(() => {
  if (token) {
    fetchProfileData();
  }
}, [token]);

// Fetch companies on component mount
useEffect(() => {
  setLoadingCountries(true);

  try {
    const list = Country.getAllCountries().map((c) => ({
      name: c.name,
      isoCode: c.isoCode,
    }));

    setCountries(list.map((c) => c.name));
    setCountriesData(list);

    setCountriesReady(true); // <-- IMPORTANT
  } catch (err) {
    toast.error(t("accountSettings.errorLoadingCountries"));
  } finally {
    setLoadingCountries(false);
  }
}, []);



useEffect(() => {
  setLoadingCountries(true);

  try {
    const list = Country.getAllCountries().map((c) => ({
      name: c.name,
      isoCode: c.isoCode
    }));

    setCountries(list.map((c) => c.name));       // for dropdown
    setCountriesData(list);                      // store ISO codes
  } catch (err) {
    toast.error(t("accountSettings.errorLoadingCountries"));
  } finally {
    setLoadingCountries(false);
  }
}, []);




// Handle country change
const handleCountryChange = (value) => {
  setSelectedCountry(value);
  setSelectedState("");
  setSelectedCity("");

  setStates([]);
  setCities([]);

  const obj = countriesData.find((c) => c.name === value);

  if (obj) {
    setSelectedCountryIso(obj.isoCode);

    const stateList = State.getStatesOfCountry(obj.isoCode).map((s) => ({
      name: s.name,
      isoCode: s.isoCode
    }));

    setStates(stateList.map((s) => s.name));
  }

  formik.setFieldValue("country", value);

  if (value === "") {
    restorePreviousLocation();
  }
};


const handleStateChange = (value) => {
  setSelectedState(value);
  setSelectedCity("");

  setCities([]);

  formik.setFieldValue("province", value);

  const obj = State.getStatesOfCountry(selectedCountryIso).find(
    (s) => s.name === value
  );

  if (obj) {
    setSelectedStateIso(obj.isoCode);

    const cityList = City.getCitiesOfState(selectedCountryIso, obj.isoCode)
      .map((c) => c.name)
      .sort();

    setCities(cityList);
  }

  if (!value) {
    restorePreviousLocation();
  }
};


const handleCityChange = (value) => {
  setSelectedCity(value);
  formik.setFieldValue("city", value);

  if (value) {
    geocodeSelection(selectedCountry, selectedState, value);
  } else {
    restorePreviousLocation();
  }
};

// Restore previous location
const restorePreviousLocation = () => {
  if (previousLocation) {
    formik.setFieldValue("latitude", previousLocation.lat);
    formik.setFieldValue("longitude", previousLocation.lng);
    formik.setFieldValue("streetAddress", previousLocation.address);
  }
};

// Load cities for existing state
const loadCitiesForState = async (country, state) => {
  try {
    setLoadingCities(true);
    const res = await fetch(`https://countriesnow.space/api/v0.1/countries/state/cities`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ country, state })
    });
    const data = await res.json();
    if (data.error === false && data.data) {
      setCities(data.data);
    }
  } catch (error) {
    console.error("Error loading cities:", error);
  } finally {
    setLoadingCities(false);
  }
};

// Geocode selection and update map
const geocodeSelection = async (country, state, city) => {
  try {
    const query = `${city}, ${state}, ${country}`;
    const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`);
    const data = await res.json();
    
    if (data && data.length > 0) {
      const result = data[0];
      const lat = parseFloat(result.lat);
      const lng = parseFloat(result.lon);
      
      // Store current location as previous before updating
      if (formik.values.latitude && formik.values.longitude) {
        setPreviousLocation({
          lat: formik.values.latitude,
          lng: formik.values.longitude,
          address: formik.values.streetAddress
        });
      }
      
      // Update form values
      formik.setFieldValue("latitude", lat);
      formik.setFieldValue("longitude", lng);
      formik.setFieldValue("streetAddress", result.display_name);
      
      // Update map location by triggering a re-render
      // The Location component will pick up the new coordinates
    }
  } catch (error) {
    console.error("Geocoding error:", error);
  }
};
  const formik = useFormik({
    initialValues: {
      firstName: '',
      middleName: '', // 👈 NEW - middle name
      lastName: '',
      community: '',
      province: '',
      city: '',
      country: 'Spain',
      postalCode: '',
      phone: '',
      dob: '', // 👈 NEW - date of birth
      regions: [],        // required
      countriesSel: [],
      citiesSel: [],
      streetAddress: '',
      latitude: null, longitude: null, timezone: '',
      countryCode: '',
      region: '',
      continent: '',
      legalDocumentUrl: "",

      // companies: [] // 👈 NEW - array of company IDs
    },
    onSubmit: async (values) => {
      try {
        setSubmitAttempted(true);

        // ---- Region is mandatory ----
      

        setSavingProfile(true);

        

        const payload = {
          firstName: values.firstName || "",
          middleName: values.middleName || "", // 👈 NEW - middle name
          lastName: values.lastName || "",
          phone: values.phone || '',
          address: values.streetAddress || '',
          city: values.city || '',
          province: values.province || '',
          postalCode: values.postalCode || '',
          country: values.country || '',
          streetAddress: values.streetAddress || "",
          profilePicture: profileImageRaw || "",
          dob: values.dob || null, // 👈 NEW - date of birth
          // legal_document_url: values.legal_document_url || "", // 👈 NEW - legal document URL
legalDocumentUrl: values.legalDocumentUrl || "",

        
          zone: values.regions || [],
          countries: values.countriesSel || [],
          cities: values.citiesSel || [],
          // companies: JSON.stringify(values.companies || []), // 👈 NEW - convert array to JSON string
          ...( !manualAddress ? {
            latitude: values.latitude ?? null,
            longitude: values.longitude ?? null,
            timezone: values.timezone || '',
            countryCode: values.countryCode || '',
            region: values.region || '',
            continent: values.continent || ''
          } : {})
        };

        const res = await fetch(`${BASE_URL}/account-executive/profile`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });
console.log("Payload to be sent:", payload);
        const data = await res.json();
        console.log("Profile update response:", data);
      if (!res.ok || data.error) {
  // ❌ API FAILED
  showToast(toast.error, data, t("accountSettings.profileUpdateFailed"));
  throw new Error(data.message || t("accountSettings.profileUpdateFailed"));
}

showToast(toast.success, data, t("alerts.accountSettings.profileUpdateSuccess"));
            dispatch(setProfile(data.data.profile));

        // Pass the updated profile data here
      } catch (err) {
  showToast(toast.error, { message: err.message }, t("alerts.accountSettings.somethingWentWrong"));
      } finally {
        setSavingProfile(false);
      }
    }
  });

  // ---- Target Region/Zone/Cities ----

  // Regions (static)
  const [regionOptions, setRegionOptions] = useState([]);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    const ALL_REGIONS = [
      "North America",
      "South America",
      "Europe",
      "Asia",
      "Africa",
      "Oceania",
    ];
    setRegionOptions(ALL_REGIONS);
    setInitLoading(false);
  }, []);

  const toArray = (input) => {
    if (Array.isArray(input)) return input;
    if (input && input.target) return input.target.value ?? [];
    return [];
  };

  // Countries from selected regions (targeting)
  const targetCountryOptions = useMemo(() => {
    if (!formik.values.regions.length) return [];
    return getCountriesByRegions(formik.values.regions).map((c) => c.name);
  }, [formik.values.regions]);

  // ---- Cities loader (same behavior as Region.js) ----
  const [citiesLoading, setCitiesLoading] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const cityLoadReqIdRef = useRef(0);
  const [selectingCity, setSelectingCity] = useState(false); // brief spinner on selection

  // Only load cities when Cities dropdown is opened
  const loadCitiesOnOpen = () => {
    if (!formik.values.countriesSel.length) return;
    if (cityOptions.length > 0) return;

    const myReqId = ++cityLoadReqIdRef.current;
    setCitiesLoading(true);

    setTimeout(() => {
      const result = getCitiesByCountryNames(formik.values.countriesSel);
      if (cityLoadReqIdRef.current === myReqId) {
        setCityOptions(result);
        setCitiesLoading(false);
      }
    }, 300); // small delay so spinner paints
  };

  // cascade clears
  const handleRegionsChange = (input) => {
    const vals = toArray(input);
    formik.setFieldValue("regions", vals);
    formik.setFieldValue("countriesSel", []);
    formik.setFieldValue("citiesSel", []);
    setCityOptions([]);
    setCitiesLoading(false);
  };

  const handleCountriesChange = (input) => {
    const vals = toArray(input);
    formik.setFieldValue("countriesSel", vals);
    formik.setFieldValue("citiesSel", []);
    setCityOptions([]);
    setCitiesLoading(false);
  };

  const handleCitiesChange = (input) => {
    const vals = toArray(input);
    setSelectingCity(true);
    startTransition(() => {
      formik.setFieldValue("citiesSel", vals);
    });
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setSelectingCity(false));
    });
  };

  // ---- Manual address toggle & other UI (unchanged) ----
  // manualAddress state is already declared above



  const handleMapLocation = useCallback((loc) => {
    if (manualAddress) return;
    formik.setFieldValue('streetAddress', loc.streetAddress || loc.address || '');
    formik.setFieldValue('city',         loc.city || '');
    formik.setFieldValue('province',     loc.province || '');
    formik.setFieldValue('community',    loc.community || '');
    formik.setFieldValue('postalCode',   loc.postalCode || '');
    formik.setFieldValue('country',      loc.country || '');
    formik.setFieldValue('latitude',     loc.latitude ?? null);
    formik.setFieldValue('longitude',    loc.longitude ?? null);
    formik.setFieldValue('timezone',     loc.timezone || '');
    formik.setFieldValue('countryCode',  loc.countryCode || '');
    formik.setFieldValue('region',       loc.region || '');
    formik.setFieldValue('continent',    loc.continent || '');
  }, [manualAddress, formik]);

  const fileInputRef = useRef(null);
  const [profileImageRaw, setProfileImageRaw] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const buildDisplayUrl = (raw) => {
    if (!raw) return "";
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;
  };

  const extractUploadUrl = (data) =>
    data?.url ||
    data?.imageUrl ||
    data?.path ||
    data?.filePath ||
    data?.location ||
    data?.result?.url ||
    data?.result?.path ||
    data?.data?.url ||
    data?.data?.path ||
    data?.data?.location ||
    "";
const [uploading, setUploading] = useState(false);
  const handleImageSelect = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const localPreview = URL.createObjectURL(file);
    setPreviewUrl(localPreview);
  setUploading(true);  
    try {
      const formData = new FormData();
      formData.append("image", file);

      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();
      if (!res.ok || json?.error) throw new Error(json?.message || t("alerts.accountSettings.imageUploadFailed"));

      const raw = extractUploadUrl(json);
      setProfileImageRaw(raw);
      setPreviewUrl(buildDisplayUrl(raw));
      toast.success(t("alerts.accountSettings.imageUploadSuccess"));
    } catch (err) {
      toast.error(err.message || t("alerts.accountSettings.uploadFailed"));
    }
    finally {
    setUploading(false);  // 🔥 stop loader
  }
  };

  useEffect(() => {
    return () => {
      if (previewUrl?.startsWith("blob:")) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const imgSrc = (profileImageRaw && buildDisplayUrl(profileImageRaw)) || previewUrl || dummy;

  // Legal document upload function
  const uploadToServer = async (file, type) => {
    const form = new FormData();
    if (type === "image") form.append("image", file);
    else form.append("pdf", file);

    const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      headers: type === "pdf" ? { Authorization: `Bearer ${token}` } : undefined,
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");

    return data?.data?.url || data?.url || data?.path || "";
  };

  const handlePickLegalDoc = () => {
    if (legalDocInputRef.current) {
      legalDocInputRef.current.accept = "image/*,.pdf,application/pdf";
      legalDocInputRef.current.click();
    }
  };

  const handleLegalDocChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Detect file type automatically
    const type = file.type.startsWith("image/")
      ? "image"
      : file.type === "application/pdf"
      ? "pdf"
      : null;

    if (!type) {
      toast.error(t("invalidFileType"));
      return;
    }

    try {
      setUploadingLegalDoc(true);
      const uploadedUrl = await uploadToServer(file, type);
      setLegalDocUrl(uploadedUrl);
      setLegalDocFile(file);
      // formik.setFieldValue("legal_document_url", uploadedUrl);
      formik.setFieldValue("legalDocumentUrl", uploadedUrl);

      toast.success(`${type.toUpperCase()} ${t("imageUploadedSuccessfully")}`);
    } catch (err) {
      toast.error(err.message || t("uploadFailed"));
      setLegalDocUrl("");
      formik.setFieldValue("legal_document_url", "");
    } finally {
      setUploadingLegalDoc(false);
      if (legalDocInputRef.current) legalDocInputRef.current.value = ""; // reset input
    }
  };

  // Delete Account Formik
  const deleteAccountFormik = useFormik({
    initialValues: {
      password: '',
      deletion_reason: '',
    },
    onSubmit: async (values) => {
      try {
        if (!values.password || !values.password.trim()) {
          toast.error(t("alerts.accountSettings.passwordRequired") || "Password is required");
          return;
        }
        if (!values.deletion_reason || !values.deletion_reason.trim()) {
          toast.error(t("alerts.accountSettings.deletionReasonRequired") || "Deletion reason is required");
          return;
        }

        setDeletingAccount(true);

        const res = await fetch(`${BASE_URL}/account-executives/me/delete`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            password: values.password,
            deletion_reason: values.deletion_reason,
          }),
        });

        const data = await res.json();
        console.log("data", data);
        
        if (!res.ok || data.error) {
          showToast(toast.error, data, t("alerts.accountSettings.accountDeletionFailed") || "Account deletion failed");
          throw new Error(data.message || t("alerts.accountSettings.accountDeletionFailed") || "Account deletion failed");
        }

        showToast(toast.success, data, t("alerts.accountSettings.accountDeletionSuccess") || "Account deleted successfully");
        
        // Clear local storage and redirect to login
        localStorage.clear();
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } catch (err) {
        showToast(toast.error, { message: err.message }, t("alerts.accountSettings.somethingWentWrong") || t("Something went wrong"));
      } finally {
        setDeletingAccount(false);
      }
    }
  });

  return (
    <>
      <Box sx={{ borderRadius: 2, px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minHeight: 55 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }} onClick={() => navigate(-1)}>
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}>
            {t("account_setting_screen.breadcrumb")}
          </CustomText>
        </Box>
      </Box>


      <Box sx={{ width: "100%", maxWidth: 700, mx: "auto", mb: 2 }}>
  <Tabs
    value={activeTab}
    onChange={(e, val) => {
      setActiveTab(val);
      if (val === 1) {
        setOpenPasswordModal(true);   // open modal instead of tab content
      }
    }}
    textColor="primary"
    indicatorColor="primary"
    sx={{
      backgroundColor: "white",
      borderRadius: 1,
      "& .MuiTab-root": {
        fontSize: "14px",
        textTransform: "none",
        fontWeight: 500,
        fontFamily: "Poppins, sans-serif",
      },
    }}
  >
    <Tab label={t("tabs.profileUpdate")} />
    <Tab label={t("tabs.changePassword")} />
    <Tab label={t("tabs.deleteAccount") || "Delete Account"} />
  </Tabs>
</Box>

{activeTab === 0 && (
      <Box sx={{ width: '100%', maxWidth: 700, mx: 'auto', backgroundColor: 'white', px: 2, borderRadius: 2, py: 3 }}>
        {/* <Toaster /> */}
        <form onSubmit={formik.handleSubmit}>
          <Box>
            {/* Image uploader (trimmed) */}
            <label className="field_label">{t("account_setting_screen.imageLabel")}</label>
      
          

            <Box sx={{ display: "flex", alignItems: "center", gap: 5, mt: 1, mb: 4 }}>


<Box sx={{ position: "relative", width: 100, height: 100 }}>

  {/* Profile Image */}
  <img
    crossOrigin="anonymous"
    src={imgSrc}
    alt="profile"
    style={{
      width: 100,
      height: 100,
      borderRadius: "50%",
      objectFit: "cover",
      opacity: uploading ? 0.4 : 1,   // fade image while uploading
    }}
     onError={(e) => {
    e.currentTarget.onerror = null; // prevent infinite loop
    e.currentTarget.src = dummy;
    }}
  />
<IconButton
  size="small"
  onClick={(e) => {
    e.stopPropagation();
    setProfileMenuEl(e.currentTarget);
  }}
  sx={{
    position: "absolute",
    top: -6,
    right: -6,
    bgcolor: "#fff",
    border: "1px solid #ccc",
    width: 28,
    height: 28,
    "&:hover": { bgcolor: "#f5f5f5" },
  }}
>
  +
</IconButton>
  {/* Loader overlay in center */}
  {uploading && (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size={28} thickness={4} sx={{ color: "#006EC2" }} />
    </Box>
  )}



  <input
    type="file"
    accept="image/*"
    ref={fileInputRef}
    style={{ display: "none" }}
    onChange={handleImageSelect}
  />
</Box>


<Menu
  anchorEl={profileMenuEl}
  open={openProfileMenu}
  onClose={() => setProfileMenuEl(null)}
>
  <MenuItem
    onClick={() => {
      setProfileMenuEl(null);
      openCameraFor("profile");
    }}
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("takePhoto")}
  </MenuItem>

  <MenuItem
    onClick={() => {
      setProfileMenuEl(null);
      fileInputRef.current?.click(); // ✅ EXISTING gallery upload
    }}
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("chooseFromGallery")}
  </MenuItem>
</Menu>

  <Box sx={{ pt: 1 }}>


  </Box>
</Box>

            {/* Basic info (trimmed to keep focus on territory changes) */}
            <Box sx={{ display: 'flex', flexWrap:"wrap", alignItems: 'center', gap: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1,minWidth:200, }}>
                <label className="field_label">{t("account_setting_screen.fullNameLabel")}</label>
                <input className="project_input" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1,minWidth:200,  }}>
                <label className="field_label">{t("middleName")}</label>
                <input className="project_input" name="middleName" value={formik.values.middleName} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 ,minWidth:200, }}>
                <label className="field_label">{t("account_setting_screen.lastNameLabel")}</label>
                <input className="project_input" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} style={{ width: '100%', height: 40 }} />
              </Box>
            </Box>

            {/* Date of Birth */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("dateOfBirth")}</label>
                <input 
                  type="date"
                  className="project_input" 
                  name="dob" 
                  value={formik.values.dob} 
                  // onChange={formik.handleChange} 
                    onChange={(e) => {
    const val = e.target.value; // format: yyyy-mm-dd
    const parts = val.split("-");
    if (parts[0] && parts[0].length > 4) {
      parts[0] = parts[0].slice(0, 4); // trim extra digits
    }
    const cleanVal = parts.join("-");
    formik.setFieldValue("dob", cleanVal); // manually set sanitized value
  }}
                  style={{ width: '100%', height: 40 }} 
                />
              </Box>
            </Box>

            {/* Phone */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1, mt: 0.8 }}>
                <label className="field_label" style={{ marginTop: "10px" }}>
                  {t("account_setting_screen.phoneLabel")} <span className="red_asterisk">*</span>
                </label>
                <Box
                  sx={{
                    border: "2px solid rgba(9,30,66,0.14)",
                    marginTop: "0px",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    "& .form-control": {
                      border: "none !important",
                      outline: "none !important",
                      boxShadow: "none !important",
                      width: "100%",
                      height: "36px",
                      fontSize: "14px",
                      paddingLeft: "48px",
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif !important",
                      backgroundColor: "transparent",
                    },
                    "& .flag-dropdown": {
                      border: "none !important",
                      borderRight: "1px solid #ccc !important",
                      backgroundColor: "#f9f9f9",
                      borderTopLeftRadius: "6px",
                      borderBottomLeftRadius: "6px",
                    },
                  }}
                >
                  <PhoneInput
                    country={"us"}
                    value={formik.values.phone}
                    onChange={(value) => formik.setFieldValue("phone", value)}
                    inputProps={{ name: "phone", required: true }}
                    containerClass="react-tel-input"
                    inputClass="form-control"
                    buttonClass="flag-dropdown"
                      disableCountryGuess={true}
  countryCodeEditable={false}
  // enableSearch={true}  
                  />
                </Box>
              </Box>
            </Box>



<Box sx={{ mb: 3, mt: 3 }}>
              <label
                style={{
                  color: "#626F86",
                  fontSize: 14,
                  marginBottom: 7,
                  display: "inline-block",
                }}
              >
                {t("legalDocument.label")}
              </label>

              <Box
                sx={{
                  position: "relative",
                  border: "2px dashed #091E4224",
                  borderRadius: "8px",
                  padding: 3,
                  textAlign: "center",
                  cursor: uploadingLegalDoc ? "not-allowed" : "pointer",
                  backgroundColor: legalDocUrl ? "#f0f8f0" : "#fafafa",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: uploadingLegalDoc ? "#fafafa" : "#f0f0f0",
                    borderColor: uploadingLegalDoc
                      ? "#091E4224"
                      : theme.palette.primary.main,
                  },
                }}
                // onClick={() => !uploadingLegalDoc && handlePickLegalDoc()}
                onClick={(e) => {
if (uploadingLegalDoc) return;
setLegalMenuEl(e.currentTarget);
}}
              >
                {uploadingLegalDoc ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <CircularProgress size={24} />
                    <CustomText sx={{ fontSize: 14, color: theme.palette.primary.main }}>
                      {t("legalDocument.uploading")}
                    </CustomText>
                  </Box>
                ) : legalDocUrl ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                      position: "relative",
                    }}
                  >
                  
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLegalDocUrl("");
                        setLegalDocFile(null);
                        formik.setFieldValue("legal_document_url", "");
                      }}
                      sx={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        bgcolor: "#fff",
                        border: "1px solid #ccc",
                        "&:hover": { bgcolor: "#f5f5f5" },
                        width: 20,
                        height: 20,
                      }}
                    >
                      <CloseRoundedIcon sx={{ fontSize: 14 }} />
                    </IconButton>

                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: theme.palette.success.main,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      ✓
                    </Box>
                    <CustomText
                      sx={{
                        fontSize: 14,
                        color: theme.palette.success.main,
                        fontWeight: 500,
                      }}
                    >
                      {legalDocFile?.name || t("legalDocument.uploaded")}
                    </CustomText>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#666",
                      }}
                    >
                     <AddIcon sx={{ fontSize: 18 }} />
                    </Box>
                    <CustomText sx={{ fontSize: 14, color: "#666" }}>
                      {t("legalDocumentUploadDescription")}
                    </CustomText>
                    <CustomText sx={{ fontSize: 12, color: "#999" }}>
                      {t("legalDocument.maxSize")}
                    </CustomText>
                  </Box>
                )}
              </Box>

             <Menu
  anchorEl={legalMenuEl}
  open={openLegalMenu}
  onClose={() => setLegalMenuEl(null)}
>
  <MenuItem
    onClick={() => {
      setLegalMenuEl(null);
      openCameraFor("legal");
    }}
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("takePhoto")}
  </MenuItem>

  <MenuItem
    onClick={() => {
      setLegalMenuEl(null);
      handlePickLegalDoc(); // ✅ EXISTING image/pdf upload
    }}
     sx={{ fontSize: "13px", fontFamily: "Poppins" }}
  >
    {t("chooseFromGallery")}
  </MenuItem>
</Menu>
              <Typography
                sx={{ fontSize: 12, color: "#888", mt: 0.5, fontFamily: 'Poppins, sans-serif', }}
              >
                {t("validation.onlyImagesAndPdf")}
              </Typography>

              <input
                ref={legalDocInputRef}
                type="file"
                accept="image/*,application/pdf"
                hidden
                onChange={handleLegalDocChange}
              />
            </Box>

            {/* Address Section - Like CreateProfile */}
            <Box mt={2.5}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000000", textAlign: "left" }}>
                  {t("account_setting_screen.addressSection")}
                </CustomText>
                <img src={down} width={40} height={30} />
              </Box>

  <Box sx={{ mt: 3, mb: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap:1,}}>
      <input
        type="checkbox"
        id="manualAddress"
        checked={manualAddress}
        onChange={(e) => setManualAddress(e.target.checked)}
        style={{ width: 18, height: 18 }}
      />
      <CustomText sx={{ ...textStyles.body4, color: "#000000" }}>
        {t("manualAddress")}
      </CustomText>
    </Box>
  </Box>


              <Box sx={{ mt: 2 }}>
  {/* Show Map section when NOT manual address */}
  {!manualAddress && (
    <Location
      onChange={handleMapLocation}
      initialLocation={
        formik.values.latitude && formik.values.longitude
          ? {
              lat: parseFloat(formik.values.latitude),
              lng: parseFloat(formik.values.longitude),
              address: formik.values.streetAddress,
              city: formik.values.city,
              country: formik.values.country,
            }
          : null
      }
    />
  )}

  {/* Manual Address Checkbox */}


  {/* Manual Address Fields (only visible when checked) */}
       {manualAddress && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
                  
                    

                    <Box>
                      <CustomText sx={{ ...textStyles.body5, color: "#6B778C", mb: 0.5 ,textAlign:"left"}}>
                        {t("country")} <span style={{ color: "red" }}>*</span>
                      </CustomText>
                      <FormControl 
                        fullWidth 
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1976d2",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: "#1976d2",
                            },
                          },
                        }}
                      >
                     <SearchableDropdown
  value={selectedCountry}
  onChange={(value) => handleCountryChange(value)}
  options={countriesData.map((c) => c.name)}
  placeholder={t("country")} // or t("selectCountry")
  disabled={loadingCountries}
/>
                      </FormControl>
                    </Box>

              
                    <Box>
                      <CustomText sx={{ ...textStyles.body5, color: "#6B778C", mb: 0.5,textAlign:"left" }}>
                        {t("province")} <span style={{ color: "red" }}>*</span>
                      </CustomText>
                      <FormControl 
                        fullWidth 
                        size="small"
                        disabled={!selectedCountry}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: selectedCountry ? "#1976d2" : "#ccc",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: selectedCountry ? "#1976d2" : "#ccc",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: selectedCountry ? "#1976d2" : "#ccc",
                            },
                          },
                        }}
                      >
                    <SearchableDropdown
  value={selectedState}
  onChange={(value) => handleStateChange(value)}
  options={states}
  placeholder={
    !selectedCountry
      ? t("selectCountryFirst")
      : t("selectProvinceState")
  }
  disabled={!selectedCountry || loadingStates}
/>
                      </FormControl>
                    </Box>

                
                    <Box>
                      <CustomText sx={{ ...textStyles.body5, color: "#6B778C", mb: 0.5,textAlign:"left" }}>
                        {t("city")} <span style={{ color: "red" }}>*</span>
                      </CustomText>
                      <FormControl 
                        fullWidth 
                        size="small"
                        disabled={!selectedState}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: selectedState ? "#1976d2" : "#ccc",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: selectedState ? "#1976d2" : "#ccc",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: selectedState ? "#1976d2" : "#ccc",
                            },
                          },
                        }}
                      >
                       <SearchableDropdown
    value={selectedState}
    onChange={(value) => handleStateChange(value)}
    options={states}
    placeholder={
      !selectedCountry
        ? t("selectCountryFirst")
        : t("selectProvinceState")
    }
    disabled={!selectedCountry || loadingStates}
  />
                      </FormControl>
                    </Box>
                  </Box>
                )}
</Box>


            </Box>

         
       
            

            <Box mt={3}>
              <CustomButton
                type="submit"
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {savingProfile && <CircularProgress size={16} sx={{ color: "#fff" }} />}
                    <img src={save} alt="save" width={16} height={16} />
                    {t("save")}
                  </Box>
                }
                size="medium"
              />
            </Box>
          </Box>
        </form>
      </Box>
)}
{activeTab === 2 && (
      <Box sx={{ width: '100%', maxWidth: 700, mx: 'auto', backgroundColor: 'white', px: 2, borderRadius: 2, py: 3 }}>
        <Toaster />
        <form onSubmit={deleteAccountFormik.handleSubmit}>
          <Box>
            <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: '#000000', textAlign: 'left', mb: 3 }}>
              {t("alerts.accountSettings.deleteAccountTitle") || "Delete Account"}
            </CustomText>

            <CustomText sx={{ ...textStyles.body4, fontSize: 14, color: '#6B778C', textAlign: 'left', mb: 3 }}>
              {t("alerts.accountSettings.deleteAccountWarning") || "Deleting your account is permanent. You will not be able to use it again. Please enter your password and provide a reason for deletion."}
            </CustomText>

            {/* Password Field */}
            <Box sx={{ mb: 3 }}>
              <label className="field_label">
                {t("alerts.accountSettings.password") || "Password"} <span className="red_asterisk">*</span>
              </label>
              <input
                type="password"
                className="project_input"
                name="password"
                value={deleteAccountFormik.values.password}
                onChange={deleteAccountFormik.handleChange}
                style={{ width: '100%', height: 40 }}
                placeholder={t("alerts.accountSettings.enterPassword") || "Enter your password"}
              />
            </Box>

            {/* Deletion Reason Field */}
            <Box sx={{ mb: 3 }}>
              <label className="field_label">
                {t("alerts.accountSettings.deletionReason") || "Reason for Deletion"} <span className="red_asterisk">*</span>
              </label>
              <TextField
                fullWidth
                multiline
                minRows={4}
                name="deletion_reason"
                value={deleteAccountFormik.values.deletion_reason}
                onChange={deleteAccountFormik.handleChange}
                placeholder={t("alerts.accountSettings.deletionReasonPlaceholder") || "Please provide a reason for deleting your account"}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "14px",
                    "& fieldset": {
                      borderColor: "#091E4224",
                      borderWidth: "2px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#1976d2",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1976d2",
                    },
                  },
                }}
              />
            </Box>

            {/* Delete Button */}
            <Box mt={3}>
              <CustomButton
                type="submit"
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {deletingAccount && <CircularProgress size={16} sx={{ color: "#fff" }} />}
                    {t("alerts.accountSettings.deleteAccount") || "Delete Account"}
                  </Box>
                }
                size="medium"
                disabled={deletingAccount}
                sx={{
                  backgroundColor: "#d32f2f",
                  "&:hover": {
                    backgroundColor: "#b71c1c",
                  },
                }}
              />
            </Box>
          </Box>
        </form>
      </Box>
    )}

<ChangePasswordSettings
  open={openPasswordModal}
  onClose={() => {
    setOpenPasswordModal(false);
    setActiveTab(0);    // return user back to Profile tab
  }}
/>

{showCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      bgcolor: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
      p: 2,
    }}
  >
    <Box
      sx={{
        width: "90%",
        maxWidth: 420,
        bgcolor: "#fff",
        borderRadius: 2,
        p: 2,
      }}
    >
      {!capturedImage ? (
        <Webcam
          ref={webcamRef}
          audio={false}
          screenshotFormat="image/jpeg"
          style={{ width: "100%", borderRadius: 8 }}
        />
      ) : (
        <img
          src={capturedImage}
          alt="Captured"
          style={{ width: "100%", borderRadius: 8 }}
        />
      )}

      <Box sx={{ display: "flex", gap: 1.5, mt: 2, justifyContent: "center" }}>
        {!capturedImage ? (
          <CustomButton
            label={takingPhoto ? t("uploading") : t("capture")}
            onClick={capturePhoto}
            disabled={takingPhoto}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedImage(null)}
          />
        )}

        <CustomButton
          label={t("close")}
          onClick={() => {
            setShowCamera(false);
            setCameraTarget(null);
            setCapturedImage(null);
          }}
          sx={{ backgroundColor: "#E0E0E0", color: "#333" }}
        />
      </Box>
    </Box>
  </Box>
)}
    </>
  );
};

export default AccountSetting;









































































































































